import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Dialog, withStyles } from '@material-ui/core';
import ColliForm from "./ColliForm";
import * as Yup from "yup";

import * as actions from './store/colliActions';
import * as warehouseActions from '../../sc-warehouses/Warehouse/store/warehouseActions';
import * as colliTypeActions from '../ColliType/store/colliTypeActions';
import * as productTypeActions from '../../sc-admin/ProductType/store/productTypeActions';
import * as groupActions from "../../sc-group/Group/store/groupActions";

import History from "../../../History";
import { hasPermission } from "../../sc-utilities";
import { snackActions } from '../../sc-utilities/SnackBar';
import moment from 'moment';
import { parseURL } from "../../sc-utilities";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const ColliCreate = props => {
    const { classes, loading, activeWarehouseID, activeCustomer, translations, permissions, createColli, onListCollies, onListWarehouses, onListColliTypes, onListGrades, onListProductTypes, fetchGroups } = props;
    const [createData, setCreateData] = useState({ collies: [], warehouses: [], colliTypes: [], loadingData: true, gradeIDs: [], productTypes: [] });
    let searchParams = parseURL(window.location.search);
    let colliType = createData.colliTypes.filter(colliType => colliType.value === searchParams.colliType)
    const [colliTypeAllow, setColliTypeAllow] = useState({});
    const [groups, setGroups] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
            let thisColliType = await onListColliTypes({ listAll: true, Deleted: false, ActiveCustomerID: activeCustomer, q: { ColliTypeID: parseURL(window.location.search).colliType } });
            thisColliType = thisColliType[0];
            setColliTypeAllow(thisColliType);
            // list collies data
            let collies = await onListCollies({ listAll: true, Deleted: false, ActiveCustomerID: activeCustomer, q: { WarehouseID: activeWarehouseID, ColliTypeID: thisColliType?.holderColliTypes } });
            if (collies instanceof Array && collies.length < 1) {
                snackActions.snackBarComponent(`${translations["no_collies_found"] || "No collies found, cannot select colli holder"}.`, "info");
            }
            // list warehouses
            let warehouses = await onListWarehouses({ listAll: true, Deleted: false, ActiveCustomerID: activeCustomer });
            if (warehouses instanceof Array && warehouses.length < 1) {
                snackActions.snackBarComponent(`${translations["no_warehouses_found"] || "No warehouses found, please create at least one warehouse first"}.`, "info");
            }
            // list colli types
            let colliTypes = await onListColliTypes({ listAll: true, Deleted: false, ActiveCustomerID: activeCustomer, q: { WarehouseID: activeWarehouseID } });
            if (colliTypes instanceof Array && colliTypes.length < 1) {
                snackActions.snackBarComponent(`${translations['colli_types_found'] || "No colli types found, please create at least one colli type first"}`, "info");
            }
            // list gradeIDs
            let gradeIDs = await onListGrades({ ActiveCustomerID: activeCustomer });
            if (gradeIDs instanceof Array && gradeIDs.length < 1) {
                snackActions.snackBarComponent(`${translations['no_grades_found'] || "No grades found, please create at least one grade first"}.`, "info");
            }
            // list product types
            let productTypes = await onListProductTypes({ ActiveCustomerID: activeCustomer });
            if (productTypes instanceof Array && productTypes.length < 1) {
                snackActions.snackBarComponent(`${translations['no_product_types_found'] || "No product types found, please create at least one product types first"}.`, "info");
            }
            setCreateData({ loadingData: false, collies: collies, colliTypes: colliTypes, warehouses: warehouses, gradeIDs: gradeIDs, productTypes: productTypes });
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const getGroups = async () => {
            const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomer });
            if (resultGroups) {
                let groupsToSet = resultGroups.data.map(group => ({ value: group.GroupID, displayValue: group.Name }));
                if (hasPermission(permissions, 'access_all_collies_on_customer')) {
                    groupsToSet = [...groupsToSet, { value: 'n/a', displayValue: 'n/a' }];
                }
                setGroups(groupsToSet);
            }
        }

        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
    }, [fetchGroups, activeCustomer, permissions]);

    const extractAllowedGrades = selectedGradeIDs => {
        if (selectedGradeIDs instanceof Array && selectedGradeIDs.length === 0) {
            let data = createData.gradeIDs.map(grade => grade.value);
            return data;
        }
        let data = selectedGradeIDs.map(allowedGradeIDs => allowedGradeIDs.value);
        return data;
    }

    const extractAllowedProductType = selectedAllowedProductType => {
        if (selectedAllowedProductType instanceof Array && selectedAllowedProductType.length === 0) {
            let data = createData.productTypes.map(allowedProductType => allowedProductType.value);
            return data;
        }
        let data = selectedAllowedProductType.map(allowedProductType => allowedProductType.value);
        return data;
    }

    const handleSubmit = async data => {
        let requestData = { ...data, ActiveCustomerID: activeCustomer }

        requestData['HolderColliID'] = requestData.HolderColliID && requestData.HolderColliID.value ? requestData.HolderColliID.value : null;
        requestData['GradeIDs'] = extractAllowedGrades(requestData.GradeIDs);
        requestData['AllowedProductTypeIDs'] = extractAllowedProductType(requestData.AllowedProductTypeIDs);
        requestData['DateStarted'] = moment(requestData.DateStarted).format();
        requestData['ArrivedAt'] = moment(requestData.ArrivedAt).format();
        requestData['DateEnd'] = requestData.DateEnd ? moment(requestData.DateEnd).format() : null;
        requestData['Finished'] = requestData.Finished ? moment(requestData.Finished).format() : null;
        if (requestData['GroupID'] === 'n/a') {
            requestData['GroupID'] = null;
        }

        let result = await createColli(requestData);
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: "",
        Description: "",
        Status: "Active",
        Locked: false,
        LockedType: "",
        HolderColliID: colliTypeAllow?.allowHolderColliIDNull ? "" : null,
        WarehouseID: searchParams.WarehouseInventoryID ? searchParams.WarehouseInventoryID : activeWarehouseID ? activeWarehouseID : '',
        ColliTypeID: searchParams.colliType ? searchParams.colliType : ' ',
        DateStarted: moment(),
        DateEnd: null,
        Finished: null,
        GradeIDs: [],
        AllowedProductTypeIDs: [],
        ArrivedAt: moment(),
        AllowHolderColliIDNull: colliTypeAllow?.allowHolderColliIDNull,
        GroupID: groups?.map(group => group?.value)?.includes('n/a') ? 'n/a' : groups?.[0]?.value ?? null
    };
    let formSettings = {
        Validation: {
            Locked: Yup.boolean(),
            Name: Yup.string().required("Required"),
            Status: Yup.string().required("Required"),
            WarehouseID: Yup.string().required("Required"),
            ColliTypeID: Yup.string().required("Required"),
            HolderColliID: Yup.string().when('AllowHolderColliIDNull', {
                is: value => typeof (value) === 'boolean' && (colliTypeAllow?.allowHolderColliIDNull),
                then: Yup.string()
                    .notRequired()
            }),
            ArrivedAt: Yup.date().required(),
            DateStarted: Yup.date().required(),
        },
        FormTitle: `${translations["create_coli"] || "Create coli"} (${colliType && colliType[0] && colliType[0].displayValue ? colliType[0].displayValue : ''})`,
        ButtonSubmit: hasPermission(permissions, 'colli_create') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return !createData.loadingData ?
        <ColliForm
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            loading={loading}
            translations={translations}
            collies={createData.collies}
            warehouses={createData.warehouses}
            colliTypes={createData.colliTypes}
            qrCode={false}
            gradeIDs={createData.gradeIDs}
            productTypes={createData.productTypes}
            groups={groups}
        /> :
        <Dialog
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            open={createData.loadingData}
            PaperProps={{
                classes: {
                    root: classes.submit
                }
            }}
        >

            <AppLogoLoading />
        </Dialog>
};

const mapStateToProps = state => {
    return {
        activeWarehouseID: state.core.login.user.ActiveWarehouseID,
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        loading: state.logistic.colli.creating,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createColli: data => dispatch(actions.createColli(data)),
        onListCollies: data => dispatch(actions.listCollies(data)),
        onListWarehouses: data => dispatch(warehouseActions.listWarehouses(data)),
        onListColliTypes: data => dispatch(colliTypeActions.listColliTypes(data)),
        onListGrades: (data) => dispatch(actions.fetchGrades(data)),
        onListProductTypes: (data) => dispatch(productTypeActions.listProductTypes(data)),
        fetchGroups: params => dispatch(groupActions.fetchGroups(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ColliCreate));

/**
 *  Translations
 *      create_colli
 */